import { render, staticRenderFns } from "./JobsChartCard.vue?vue&type=template&id=66ffb98c&scoped=true&"
import script from "./JobsChartCard.vue?vue&type=script&lang=js&"
export * from "./JobsChartCard.vue?vue&type=script&lang=js&"
import style0 from "./JobsChartCard.vue?vue&type=style&index=0&id=66ffb98c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ffb98c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VListItem,VListItemContent,VListItemTitle,VSelect,VSpacer})
